import {log} from "gulp-util";
var wcEventsList = [
    'init_checkout',
    'payment_method_selected',
    'update_checkout',
    'updated_checkout',
    'checkout_error',
    'applied_coupon_in_checkout',
    'removed_coupon_in_checkout',
    'wc_cart_emptied',
    'update_checkout',
    'updated_wc_div',
    'updated_cart_totals',
    'country_to_state_changed',
    'updated_shipping_method',
    'applied_coupon',
    'removed_coupon',
    'adding_to_cart',
    'added_to_cart',
    'removed_from_cart',
    'wc_cart_button_updated',
    'cart_page_refreshed',
    'cart_totals_refreshed',
    'wc_fragments_loaded',
    'hide_variation',
    'show_variation',
    'woocommerce_variation_select_change',
    'woocommerce_variation_has_changed',
    'check_variations',
    'woocommerce_update_variation_values',
    'woocommerce_gallery_reset_slide_position',
    'woocommerce_gallery_init_zoom'
];




(function ($) {
    function centerArrow(slider) {
        let img = $(`${slider} img`);
        let arrow = $(`${slider} .slick-arrow`);
        arrow.css({
            top: img.height() / 2 - arrow.height() / 2,
        })
    }

    function masonryImageHeight() {
        $('.gallery-section .gallery-item:first-child .gallery-img > img, .gallery-section .gallery-item:nth-child(2) .gallery-img > img, .gallery-section .gallery-item:nth-child(13) .gallery-img > img, .gallery-section .gallery-item:nth-child(14) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 0.68)
        })
        $('.gallery-section .gallery-item:nth-child(3) .gallery-img > img, .gallery-section .gallery-item:nth-child(4) .gallery-img > img').each(function () {
            var curWidth = $('.gallery-section .gallery-item:nth-child(4) img').width();
            $(this).css('height', curWidth * 0.759)
        })
        $('.gallery-section .gallery-item:nth-child(5) .gallery-img > img, .gallery-section .gallery-item:nth-child(6) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 0.755)
        })
        $('.gallery-section .gallery-item:nth-child(7) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 1.185)
        })
        $('.gallery-section .gallery-item:nth-child(8) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 0.538)
        })
        $('.gallery-section .gallery-item:nth-child(9) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 1.009)
        })
        $('.gallery-section .gallery-item:nth-child(11) .gallery-img > img').each(function () {
            var curWidth = $(this).width();
            $(this).css('height', curWidth * 0.948)
        })
        $('.gallery-section .gallery-item:nth-child(10) .gallery-img > img, .gallery-section .gallery-item:nth-child(12) .gallery-img > img').each(function () {
            var curWidth = $('.gallery-section .gallery-item:nth-child(4) a > img').width();
            $(this).css('height', curWidth * 0.344)
        })
    }

    function toggleAccordion(elem, holderSelector, toggledClassName) {
        const $this = $(elem)
        const holder = $this.find(holderSelector)
        $this.toggleClass(toggledClassName)
        $this.hasClass(toggledClassName) ? holder.slideDown() : holder.slideUp()
    }

    var isConfirm = false

    function clickLinkInPayment(e) {
        if (isConfirm) return

        isConfirm = confirm('אנא השלם את הרכישה\n' + 'או ליציאה ממסך זה לחץ על ביטול בטופס')
        if (isConfirm) {
            e.preventDefault()
        }
    }

    function onBeforeUnloadHandler(e) {
        e.returnValue = 'Are you sure you want to leave?'
        return 'Are you sure you want to leave?';
    }

    Fancybox.bind('.other-blogs-card .video-holder', {
        Thumbs: {autoStart: false}
    })

    const sliderOptions = {
        infinite: true,
        arrows: true,
        rtl: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
    }

    function initComplementaryItemsMobileSlider() {
        $('.complementary-items').slick({
            rtl: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true
        })
        centerArrow('.complementary-items')

        $('.complementary-product h3').equalizeHeight({
            equaltop: false
        })
    }



    var nav_slider = $('.nav-slider');
    function initSliderWithNav() {

        nav_slider.Startlength = nav_slider.find('img').length;
        if(nav_slider.find('img').length > 1){
            nav_slider.slick({
                ...sliderOptions,
                arrows: true,
                dots: true,
                slidesToShow: nav_slider.find('img').length >4 ? 4 : nav_slider.find('img').length + 0.9 - 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                swipe: true,
                autoplay: false,
                // asNavFor: '.slider-with-nav',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            dots: false,
                        }
                    }
                ]
            })
        }else {
            nav_slider.find('img').addClass('slick-slide');
            var nav_slider_slide = nav_slider.find('.slick-slide');
            nav_slider_slide.each(function (){
                $(this).click(function (){
                    var nav_slider_active_slide_first = $(this);

                    var nav_slider_active_mainSlide_image = nav_slider_active_slide_first.attr('data-src');
                    var slider_main_image = $('img.slider-with-nav-main-image-main');
                    var slider_fade_image = $('img.slider-with-nav-main-image-fade');
                    slider_fade_image.attr('src', nav_slider_active_mainSlide_image);
                    slider_main_image.parent().attr('href', nav_slider_active_mainSlide_image);
                    slider_fade_image.css({
                        display : 'block',
                        opacity : 1
                    });

                });
            })
            nav_slider_slide.eq(0).click();
        }


        var counter =true ;

        $('img.slider-with-nav-main-image-main, img.slider-with-nav-main-image-fade').on('load',function (){
            $('.slider-with-nav-main-image').css({height : $(this).height() + 'px'});
            if(counter){
                counter=!counter;
                return;
            }
            var slider_main_image = $('img.slider-with-nav-main-image-main');
            var slider_fade_image = $('img.slider-with-nav-main-image-fade');
            slider_fade_image.fadeIn(500,function () {
                slider_fade_image.removeClass('slider-with-nav-main-image-fade').addClass('slider-with-nav-main-image-main');
            });
            slider_main_image.fadeOut(500,function (){
                slider_main_image.removeClass('slider-with-nav-main-image-main').addClass('slider-with-nav-main-image-fade');
            });
        })
        var container = document.querySelector('.slider-with-nav__wrapper');

        var listener = SwipeListener(container);

        container.addEventListener('swipe', function (e) {
            console.log('swipe', e.detail);
            var d = e.detail.directions;

            if (d.top) {
                if (d.right) {
                    console.log("Swiped right!");
                    $('.slider-with-nav__wrapper .slick-next').click();
                } else if (d.left) {
                    console.log("Swiped left!");
                    $('.slider-with-nav__wrapper .slick-prev').click();
                }
            } else if (d.bottom) {
                if (d.right) {
                    console.log("Swiped right!");
                    $('.slider-with-nav__wrapper .slick-next').click();
                } else if (d.left) {
                    console.log("Swiped left!");
                    $('.slider-with-nav__wrapper .slick-prev').click();
                }
            } else {
                if (d.right) {
                    console.log("Swiped right!");
                    $('.slider-with-nav__wrapper .slick-next').click();
                } else if (d.left) {
                    console.log("Swiped left!");
                    $('.slider-with-nav__wrapper .slick-prev').click();
                }
            }
        });

        nav_slider.on('afterChange', function (){
            console.log(nav_slider.find('img.slick-active'));
            console.log(nav_slider.find('img.slick-active').length);
            if(nav_slider.Startlength > 4){
                var nav_slider_active_slide_first = nav_slider.find('img.slick-active').first();

            }else if(nav_slider.Startlength == 4){
                var nav_slider_active_slide_first = nav_slider.find('img.slick-active').length ==3 ? nav_slider.find('img.slick-active').first() : nav_slider.find('img.slick-active').eq(1);

            }else if(nav_slider.Startlength == 3){
                var nav_slider_active_slide_first = nav_slider.find('img.slick-active').length ==3 ? nav_slider.find('img.slick-active').eq(1) : nav_slider.find('img.slick-active').first();

            }else if(nav_slider.Startlength == 2){
                var nav_slider_active_slide_first = nav_slider.find('img.slick-active').length ==1 ? nav_slider.find('img.slick-active').first() : nav_slider.find('img.slick-active').eq(1);

            }
            var nav_slider_active_mainSlide_image = nav_slider_active_slide_first.attr('data-src');
            var slider_main_image = $('img.slider-with-nav-main-image-main');
            var slider_fade_image = $('img.slider-with-nav-main-image-fade');
            slider_fade_image.attr('src', nav_slider_active_mainSlide_image);
            slider_main_image.parent().attr('href', nav_slider_active_mainSlide_image);
            slider_fade_image.css({
                display : 'block',
                opacity : 1
            });
            var newDescriptionValue = $('.slick-current').data('description');
            $('.data_description').text(newDescriptionValue);

        })
        var descriptionValue = $('.nav-slider .slick-slide').data('description');
        var dataDescriptionElement = $('<p class="data_description"></p>').text(descriptionValue);
        $('.nav-slider').prepend(dataDescriptionElement);
        $(".nav-slider .slick-slide").click(function() {
           var el= $(this).data('description');
           var dataDescriptionElement = $('<p class="data_description"></p>').text(el);

            $('.nav-slider').find('.data_description').remove();
            $('.nav-slider').prepend(dataDescriptionElement);
        });




        var slider_arrows = $('.nav-slider .slick-arrow')
        $('.slider-with-nav-main-image').append(slider_arrows);
    }
window.initSliderWithNav = initSliderWithNav
    function initProductSliders() {
        let productSliderInitTimer = setInterval(function () {
            if ($('.slider-with-nav__wrapper').length) {

                initSliderWithNav()
                $('.complementary-product h3').equalizeHeight({
                    equaltop: false
                })

                if ($(window).width() < 640) {
                    initComplementaryItemsMobileSlider()
                }

                clearInterval(productSliderInitTimer)
            }

        }, 200);
    }

    function addNoSaleClass() {
        let noSaleClass = setInterval(function () {
            const noSaleIdentifier = $('s')
            if (noSaleIdentifier.length) {
                const productParent = $('.product-characteristics').length
                    ? noSaleIdentifier.closest('.product-characteristics')
                    : noSaleIdentifier.closest('.has-status')
                productParent.addClass('no-sale-product')
                clearInterval(noSaleClass)
            }
        }, 200)
    }

    function setProductsColors() {
        const colorsData = _vsc_static_item_json.res.VSNotesTab[0]
        const regColors = /(<b ([a-z]+-*[0-9]*-*[a-zA-z]*)\s*>\s*<u>([\u0590-\u05FF\s]*)<\/u><\/b>)/gmi
        const allColors = colorsData[1] && colorsData[1][1] ? colorsData[0][1] + colorsData[1][1] : colorsData[0][1]
        const colorsArr = Array.from(allColors.matchAll(regColors)).map((item) => {
            return [item[2], item[3]]
        })

        let colorsRender = setInterval(function () {
            if ($('.product-characteristics').length) {
                for (let color of colorsArr) {
                    $('.product-colors').append(`<div class="product-color">
                                                    <div class="color ${color[0]}"></div>
                                                    <p>${color[1]}</p>
                                                 </div>`)
                }
                clearInterval(colorsRender)
            }
        }, 500)
    }

    function toggleErrorField(field, message, validation) {
        const fieldParent = field.closest('div')
        const error = fieldParent.find('.error-message')
        if (validation) {
            fieldParent.removeClass('error').addClass('valid');
            error.remove();
        } else {
            fieldParent.removeClass('valid').addClass('error');
            error.length ? null : fieldParent.append(`<p class="error-message"> ${message} </p>`)
        }
    }

    function validateTextField(textField) {
        const field = $(textField);
        const isValid = field.val().trim().length > 0;
        toggleErrorField(field, 'שדה זה הוא חובה למילוי', isValid);
    }

    function validateEmail(emailField) {
        const field = $(emailField);
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const isValid = regex.test(field.val())
        toggleErrorField(field, 'כתובת דוא"ל שהזנת אינה תקינה', isValid)
    }

    function validateTelField(telField) {
        const field = $(telField);
        const regex = /([0-9]{2}-*)([0-9]{2}-*)[0-9]{5,6}/
        const isValid = field.val().match(regex);
        toggleErrorField(field, '<span class="error-message"> מספר טלפון שהזנת אינו תקין </span >', isValid)
    }
    $(document).ready(function () {
        $('#webTicker').webTicker({
            startEmpty: false,
            duplicate: true,
            speed: 100,
            hoverpause: true,
            height: '51px',
            direction: 'right',
        });

        if ($('.page-template-template-product').length || $('.page-template-template-category').length) {

            addNoSaleClass()
            window.addEventListener('message', function (e) {
                const eventData = JSON.parse(e.data)
                if (eventData.gridChange) {
                    addNoSaleClass()
                }
            })
        }



        if ($('.page-template-template-product').length) {
            initProductSliders()
            setProductsColors()
            let setSliderArrow = setInterval(function () {
                if ($('.slick-active .complementary-item img').length && $('.slick-active .complementary-item img').height() > 50) {
                    centerArrow('.complementary-items');
                    clearInterval(setSliderArrow)
                }
            }, 200)
        }

        if (!($('textarea.comment').val())) {
            localStorage.removeItem('comment')
        }

        $('.slider').each(function () {
            if ($(this).is('.blogs-slider')) {
                $(this).slick({
                    slidesToShow: 2,
                    ...sliderOptions,
                    responsive: [
                        {
                            breakpoint: 851,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                })
            } else if ($(this).is('.articles-slider')) {
                $(this).slick({
                    slidesToShow: 4,
                    ...sliderOptions,
                    responsive: [
                        {
                            breakpoint: 1470,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 851,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                })
            } else if ($(this).is('.top-slider, .blog-slider')) {
                $(this).slick({
                    fade: true,
                    ...sliderOptions
                })
            }
        })

        $('.single-question').on('click', function () {
            toggleAccordion(this, '.answer-holder', 'answer-open')
        })

        $(document).on('click', '.product-accordion .info-item', function () {
            toggleAccordion(this, '.info', 'opened-info')
        })

        $('.menu-opener').click(function () {
            $('.menu-opener,  .header-menu, #header').toggleClass('active');
            $('body').toggleClass('no-scroll');
        });

        $('.call-us').click(function (e) {
            e.preventDefault();
            $('.call-us').toggleClass('active');
            $('.call-us-submenu').slideToggle();
            $(this).focus();
            return false;
        });
        $('.contact-as-whatsapp').click(function (e) {
            e.preventDefault();
            $('.contact-as-whatsapp').toggleClass('active');
            $('.whatsapp-submenu').slideToggle();
            $(this).focus();
            return false;
        });
        $(".header-contacts").on('focusout',function(){
            $('.call-us').removeClass('active');
            $('.call-us-submenu').slideUp();
            $('.contact-as-whatsapp').removeClass('active');
            $('.whatsapp-submenu').slideUp();
        });

        if ($(window).width() < 639) {
            $("li.menu-item-has-children").on("click", function () {
                const li = $(this)
                const subMenu = li.find(".sub-menu")

                if (li.hasClass(".active-sub-menu")) {
                    li.removeClass(".active-sub-menu")
                    subMenu.slideUp()
                    return
                }

                li.addClass(".active-sub-menu")
                subMenu.slideDown()
            })
        }

        $('.text-info-content .play-btn').on('click', function () {
            const video = $('.text-info-content video')
            $('.text-info-content .local-video').toggleClass('played-video')
            video[0].paused ? video[0].play() : video[0].pause()
        })


        if ($('.faq-page').length) {
            $('.faq-menu a').on('click', function () {
                $('html, body').animate({
                    scrollTop: $($(this).attr('href')).offset().top - $('header').height()
                }, 500);
            })
        }

        $(document).on('click', '.to-cart-btn', function () {
            const cart = $('.mini-cart-container')
            cart.show()
            setTimeout(function () {
                cart.hide()
            }, 3000)
        })

        if ($('#VSCreditIframe').length) {
            window.addEventListener('message', (event) => {
                const messageData = JSON.parse(event.data)
                if (messageData.id === "checkout_report") {
                    $('a:not([data-wiz-step="2"])').off('click', clickLinkInPayment)
                    $(window).off('beforeunload', onBeforeUnloadHandler);
                    return
                }

                if (messageData.object_id == 'payment' && messageData.status_report_off) {
                    $('a:not([data-wiz-step="2"])').on('click', clickLinkInPayment)
                    $(window).on('beforeunload', onBeforeUnloadHandler);
                }

                if (messageData.wizclickpos && messageData.wizshop) {
                    $('.paycomment textarea').val(localStorage.getItem('comment'))
                }
            });
        }

        const monthObj = {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: "May",
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December',
        }

        $('.month-wrapper select').on('change', function () {
            const monthVal = $(this).val()
            const daySelect = $('.days-wrapper select')

            if (monthVal) {
                $('.days-wrapper option:not(:first)').remove()
                $('#vs_OrdExDataTab').val(monthVal)
            } else {
                daySelect.attr('disabled', 'disabled')
                $('#vs_OrdExDataTab').val('not-chosen')
            }

            for (let monthIndex in monthObj) {
                if (monthVal === monthObj[monthIndex]) {
                    const currentYear = new Date().getFullYear()
                    const daysCount = new Date(currentYear, +monthIndex, 0).getDate()

                    for (let i = 1; i <= daysCount; i++) {
                        daySelect.append(`<option value="${i}"> ${i} </option>`)
                    }

                    daySelect.removeAttr('disabled')
                }
            }
        })
        $('.days-wrapper select').on('change', function () {
            const dayVal = $(this).val()
            const monthVal = $('.month-wrapper select').val()

        })

        $('#additional_month').on('change', function () {
            const monthVal = $(this).val();
            const daySelect = $('#additional_day');

            if (monthVal) {
                daySelect.find('option:not(:first)').remove();
            } else {
                daySelect.attr('disabled', 'disabled');
            }

            const currentYear = new Date().getFullYear();
            const daysCount = new Date(currentYear, $('#additional_month option').index($('#additional_month option:selected')), 0).getDate();

            for (let i = 1; i <= daysCount; i++) {
                daySelect.append(`<option value="${i}">${i}</option>`);
            }

            daySelect.removeAttr('disabled');
        });


            $('#additional_day').on('change', function () {
                $(this).siblings('.error-message').animate({opacity: 0, zIndex: -1}, 300);
            });

        $('textarea.comment').on('change', function () {
            localStorage.setItem('comment', $(this).val())
        })

        $('.checkout .validate-required input').on('change blur', function () {
            const checkoutBtn = $('.checkout .btn');
            const reqFiledsLength = $('.checkout input[data-req]').closest('div').length
            const validFieldsLength = $('.checkout input[data-req]').closest('div.valid').length

            if (reqFiledsLength === validFieldsLength) {
                checkoutBtn.removeAttr('disabled')
            } else {
                checkoutBtn.attr('disabled', 'disabled')
            }
        })

   /*     $('.checkout input[type="text"]').on('input blur focus', function () {
            validateTextField(this)
        })

        $('.checkout input[type="email"]').on('input blur focus', function () {
            validateEmail(this)
        })

        $('.checkout input[type="tel"]').on('input blur focus', function () {
            validateTelField(this)
        })*/

        $(".checkout .first-name, .checkout .last-name").on("blur", function () {
            const firstNameValue = $(".checkout .first-name").val()
            const lastNameValue = $(".checkout .last-name").val()
            const fullNameInput = $(".checkout .full-name")

            fullNameInput.val(`${firstNameValue} ${lastNameValue}`.trim())
        })

        if ($('.slider-with-nav__wrapper').length) {
            initSliderWithNav()
        }
        $(document).on("click", ".open-popup a", function (e) {
            e.preventDefault()
            $("body").addClass("opened-popup")
            $(".product-popup").addClass("open")
        })

        $(".close-popup").on("click", function (e) {
            e.preventDefault()
            $(this).closest(".popup-backdrop").removeClass("open")
            $("body").removeClass("opened-popup")
        })

        $(document).on("click", ".popup-backdrop", function (e) {
            const $targetEl = $(e.target)
            const $currentEl = $(e.currentTarget)

            if($currentEl.is($targetEl)) {
                $("body").removeClass("opened-popup")
                $currentEl.removeClass("open")
            }
        })

        $('.attr-product select').prop('selectedIndex', 0);
        $('.attr-product select').not('#pa_color').selectric();

        setTimeout(function (){
            $('#pa_color').selectric({
                optionsItemBuilder: function (item){
                    var elColor =  $('[data-color="'+ (item.value) +'"] .color')
                    var elSpan = elColor.length > 0 ? '<span>' + elColor.prop('outerHTML') + '</span>' : ('');
                    return item.text + elSpan;
                },
            });
        },600)

        var changeSliderImageTimer = false

        $('#pa_color').on('change', function () {
            var selectedColor = /*decodeURIComponent(*/$(this).val()/*)*/;
            $('.product-color').removeClass('active');
           var elColor =  $('.product-color[data-color="'+ selectedColor +'"]');
           elColor.addClass('active');
            let img = elColor.attr('data-img');
            changeSliderImageTimer = setTimeout(function (){
                img && $('.slider-with-nav-main-image-fade').attr('src', img);
                changeSliderImageTimer = false;
            },50);
            $('.product-color').each(function () {
                var dataColor = $(this).data('color');
                if (selectedColor === dataColor) {
                    $(this).addClass('active');
                }
            });
        });

        $('.product-color').click(function (){
            //var color = encodeURIComponent($(this).attr('data-color')).toLocaleLowerCase();
            var color = $(this).attr('data-color');
            $('#pa_color').val(color);
            $('#pa_color').change()
            $('#pa_color').selectric('refresh');
        })

        $('form.cart').on('woocommerce_update_variation_values', function (e){
            var vals = [];
            $('#pa_color option').each(function (){
                vals.push($(this).attr('value'))
            });
            $('.product-color').each(function (){
                $(this).toggleClass('not-color', vals.indexOf($(this).attr('data-color')) === -1)
            });
        });
        $('form.cart').on('woocommerce_variation_has_changed', function (e, variation){
            var $this = $(this);
            var variationId =parseFloat($(this).find( "input.variation_id" ).val());
            var variations = $(this).data('product_variations');
            if(variations && variations.length && !variationId){
                showLowestVariationPrice();
                return;
            }
            var currentVariation = null;
            if(variationId && variations && variations.length){
                currentVariation = variations.reduce(function (selected, current){
                    return current.variation_id == variationId ? current : selected;
                },currentVariation)
            }
            if(currentVariation && currentVariation.image && currentVariation.image_id){
                if(changeSliderImageTimer){
                    clearTimeout(changeSliderImageTimer)
                    changeSliderImageTimer = false;
                }
                $('.slider-with-nav-main-image-fade').attr('src', currentVariation.image.url);

            }
            $(this).find('select').selectric('refresh');
            setTimeout(function (){
                $this.find('select').selectric('refresh');
            },500);
        })

        var firstSet = true;
        function showLowestVariationPrice(){
            var variations = $('form.cart').data('product_variations').filter(function (variation){
                for(key in variation.attributes){
                    var val =$('[name="'+key+'"]').val();
                    return !val || val == variation.attributes[key]
                }
            });
            var lowestVariation = variations[0];
            var prices =[];
            lowestVariation = variations.reduce(function (selected, current){
                prices.push(current.display_price);
                return current.display_price < selected.display_price ? current : selected;
            },lowestVariation);
            prices = prices.filter((value, index, array)=> array.indexOf(value) === index);
            if( prices.length>1 && !firstSet ){
                $('form.cart .prices.single_variation').stop().css({'display':'block'}).html(lowestVariation.price_html);
                $('form.cart .prices.single_variation').find('del').remove();
                $('form.cart .prices.single_variation').find('.woocommerce-Price-amount').prepend('<span>סכום לתשלום החל מ-</span>');
                var key
                for(key in lowestVariation.attributes){
                    $('[name="'+key+'"]').val(lowestVariation.attributes[key]);
                }
                $('[name="'+key+'"]').change();
            }else {
                $('form.cart .prices.single_variation').stop().css({'display':'block'}).html(lowestVariation.price_html);
                $('form.cart .prices.single_variation').find('del').remove();
                $('form.cart .prices.single_variation').find('.woocommerce-Price-amount').prepend('<span>מחיר:</span>');
            }
            firstSet = false;
            setTimeout(function (){
                jQuery('select').selectric('refresh');
            },1000);
        }
        setTimeout(function (){
            $('form.cart').trigger('woocommerce_variation_has_changed');
        },400);


        /* change select, checked radio*/

           $('#shipping_method').selectric();
           $(document.body).on("updated_checkout", function (){
                 $('#shipping_method').selectric();
            })

           $(document.body).on('change','#shipping_method', function(){
            var selectedValue = $(this).val();
            $('input[name="shipping_method[0]"]').filter('[value="' + selectedValue + '"]').prop('checked', true);
        });





        $( "input" ).focus(function() {
            $( this ).parent().siblings('label').animate({opacity: 0}, 500 );
        });


        $(document).on('blur', '.woocommerce-input-wrapper input',  labelShow)
        function labelShow (){
            const input = $(this)
            if (input.val().length) {
                $(this).parent().siblings('label').animate({opacity: 0}, 0 )
            } else {
                $(this).parent().siblings('label').animate({opacity: 1}, 500 );
            }
        }
        $('.woocommerce-input-wrapper input').each(labelShow);

        /*close autocomplete*/
        $(document).mouseup(function (e) {
            var container = $(".header-search .search-form");
            if (container.has(e.target).length === 0) {
                $('.autocomplete-wrap').css('display', 'none');
            }
        });
        $('.autocomplete-item a').on('click', function() {
            $(this).closest('.autocomplete-wrap').css('display', 'none');
        });


         /*form checkout page $( document.body ).trigger( 'checkout_error' );*/
        $(document.body).on('checkout_error', function(event) {
                 if ($('body.page-template-template-checkout').length) {
                     $('.woocommerce-error li').each(function() {
                         var dataId = $(this).data('id');
                         var inputField = $('#' + dataId);
                         inputField.after('<span class="error-message">' + $(this).text() + '</span>');
                     });
                 }
                 $('.for_place_order').remove();
                 $('#place_order').before('<div class="form-row woocommerce-invalid for_place_order"><label for="place_order">אחד או יותר שדות בטופס לא מולאו תקין. </label></div>');

        })



        $('pform[name="checkout"]').submit(function(event) {
            var requiredFields = $('.validate-required input, .validate-required select');
            var isValid = true;

            requiredFields.each(function() {
                var field = $(this);
                if (field.val().trim() === '') {
                    isValid = false;
                    field.parent().addClass('error');
                } else {
                    field.parent().removeClass('error');
                }
            });

            if (!isValid) {
                event.preventDefault();
                var formOffset = $('form[name="checkout"]').offset().top - 100;
                $('html, body').animate({ scrollTop: formOffset }, 1500);
                $('.validate-required').addClass('error');
                $(".error-message").css('display', 'block')
            }
        });


        var quantityProduct = $('.quantity-product');
        var inputElement = quantityProduct.find('div.quantity input[type="number"]');
       if(!inputElement.length <= 0){
            var minCount = quantityProduct.data('min-count');
            var maxCount = quantityProduct.data('max-count');
            var selectElement = document.createElement('select');
            selectElement.classList.add('select-quantity');
            quantityProduct.prepend(selectElement);
            setTimeout(function (){
                selectElement.options.length = 0;
                for (var i = minCount; i <= maxCount; i++) {
                    selectElement.options[selectElement.options.length] = new Option(i, i);
                }
                selectElement.selectedIndex = 0;
                $(".quantity-product .select-quantity").selectric();

            },400);
      }


        $(selectElement).change( function() {
            inputElement.val($(this).val());
            inputElement.trigger('change');
        });



         var elPrices = $(".prices").children('.woocommerce-Price-amount');
        if(elPrices.length === 2){
            elPrices.first().addClass('old-price');
        }
        $(document).on('click','.single_add_to_cart_button', function (){
            setTimeout(function () {
                $(document).find('.shopping-cart-holder').addClass('hover');
            },3000)
        })
       /*close mini-cart*/
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.shopping-cart-holder').length) {
                $('.shopping-cart-holder').removeClass('hover');
            }
        });

        $('.prices.single_variation').each(function() {
            if ($(this).find('.no-sale-price').length > 0) {
                $(this).find('.no-sale-price, del, ins').wrapAll('<div class="wrapper-text-price"></div>');
            }
        });
    });

    setTimeout(function (){
        $(".animation-container").addClass("fade");
    },8000);

    $(window).on('load', function () {
        $(".grid").masonry({
            columnWidth: 1,
            originLeft: false
        });

        $.scroll_to_notices = function(){

        }

        window.preloadedImages = [];
        $('.nav-slider img[data-src]').each(function (){
            var img = new Image()
            img.src = $(this).attr('data-src')
            window.preloadedImages.push(img)

        });

        $(".animation-container").addClass("fade");

        var nav_slider_active_slide_first = nav_slider.find('.slick-active').first();
        var nav_slider_active_mainSlide_image = nav_slider_active_slide_first.attr('data-src');
        var slider_main_image = $('img.slider-with-nav-main-image-main');
        slider_main_image.attr('src', nav_slider_active_mainSlide_image);
        slider_main_image.parent().attr('href', nav_slider_active_mainSlide_image);
    });

    $('.checkout [data-wiz-step="3"]').on('click', function () {
        $('html, body').animate({
            scrollTop: $('.main-container').offset().top
        }, 1000)
        $('.main-container').addClass('step-3')
    })

    $('.checkout [data-wiz-step="2"]').on('click', function () {
        $('.main-container').removeClass('step-3')
    })

    $(window).on('load resize', debounce(function () {
        masonryImageHeight();
        adjustHeights();
        centerArrows();
        setupInputPlaceholders();
    }, 250));

    function adjustHeights() {
        // Элементы с equaltop: false
        const elementsFalse = [
            '.blogs .description-wrap',
            '.products .img-holder',
            '.products-headline .description',
            '.other-blogs-card .description p',
            '.other-blogs-card .headline',
            '.branch-info',
            '.complementary-product h3'
        ];

        // Элементы с equaltop: true
        const elementsTrue = [
            '.products-headline h3',
            '.subcategory-gallery .headline h3',
            ".gallery-item-wrap .headline p",
            '.sale-gallery .headline h3',
            '.sale-gallery .headline p',
            '.sale-gallery .products-block h3',
            '.sale-gallery .products-block p'
        ];

        // Применение функции equalizeHeight
        elementsFalse.forEach(selector => {
            $(selector).equalizeHeight({ equaltop: false });
        });

        elementsTrue.forEach(selector => {
            $(selector).equalizeHeight({ equaltop: true });
        });
    }

    function centerArrows() {
        const sliders = [
            '.blogs-slider',
            '.articles-slider',
            '.products-wrap',
            '.other-blogs-slider'
        ];

        sliders.forEach(selector => {
            centerArrow(selector);
        });
    }

    function setupInputPlaceholders() {
        $(document).on('input', '.payment-info input', function () {
            const input = $(this);
            const placeholder = input.next('.placeholder');
            placeholder.css('display', input.val().length ? 'none' : 'block');
        });
    }

// Функция debounce
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    $(window).on('load resize orientationchange', function () {
        $('.mobile-slider').each(function () {
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 639) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            } else {
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        rtl: true,
                        arrows: true
                    });
                }
            }
        });
    });

    let viewer = null;

    const addImagePopup = (imgSrc) => {
        const elementPopup = $('.popup-slide-img');
        const elementImg = $('.popup-slide-img .wrap-img img');

        $(elementImg).attr('src', `${imgSrc}`);
        $(elementPopup).addClass('active');
        openPopupDragon(imgSrc);
    }

    $(document).on('click', '.product-page .slider-with-nav .slick-slide', function (e) {
        e.preventDefault();
        let imgSrc = $(this).find('img').attr('src');
        addImagePopup(imgSrc);
    });
    $(document).on('click', '.popup-slide-img .close-btn', function (e) {
        e.preventDefault();
        closePopup();
        let element = $(this).closest('.popup-slide-img');
        $(element).removeClass('active');
    });

    $(document).on('click', '.popup-slide-img', function (e) {
        e.preventDefault();
        if($(e.target).hasClass('popup-slide-img')) {
            $(this).removeClass('active');
        }
    });

    function openPopupDragon(imgSrc) {
        viewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: {
                type: 'image',
                url: imgSrc
            }
        });
    }

    function closePopup() {
        if (viewer) {
            viewer.destroy();
            viewer = null;
        }
    }

})(jQuery)





